import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { RouterModule } from "@angular/router";
import { AcquisitionRoutingModule } from "./acquisition-routing.module";
import { AcquisitionGenericEffects } from "./state/+acquisition-generic/acquisition-generic.effects";
import { EffectsModule } from "@ngrx/effects";
import { AcquisitionGenericFacade } from "./state/+acquisition-generic/acquisition-generic.facade";
import { StoreModule } from "@ngrx/store";
import * as acquisitionGenericReducer from "./state/+acquisition-generic/acquisition-generic.reducer";
import { AcquisitionContainerComponent } from "./containers/acquisition-container/acquisition-container.component";
import { AcquisitionComponent } from "./components/acquisition/acquisition.component";
import * as acquisitionReducer from "./state/+acquisition/acquisition.reducer";
import { AcquisitionEffects } from "./state/+acquisition/acquisition.effects";
import { AcquisitionFacade } from "./state/+acquisition/acquisition.facade";
import { AngularMaterialModule } from "@cradua/material";
import { AcquisitionListComponent } from "./components/acquisition/acquisition-list/acquisition-list.component";
import { EpimsDashboardNavModule } from "@cradua/epims-dashboard-nav";
import { SpinnersModule } from "@cradua/spinners";
import { PaymentModule } from "@cradua/payment";
import { SearchComponent } from "./components/acquisition/search/search.component";
import { GatewayFacade } from "libs/gateway/src/lib/states/+gateway/gateway.facades";
import { CreateAcquisitionComponent } from './components/acquisition/create-acquisition/create-acquisition.component';
import { ReactiveFormsModule } from "@angular/forms";
import { MeasurementConversionTableComponent } from './components/acquisition/create-acquisition/measurement-conversion-table/measurement-conversion-table.component';
import { LandParcellationComponent } from './components/acquisition/create-acquisition/land-parcellation/land-parcellation.component';
import { GeoSpatialComponent } from './components/acquisition/create-acquisition/geo-spatial/geo-spatial.component';
import { StorageLocationComponent } from './components/acquisition/create-acquisition/storage-location/storage-location.component';
import { DocumentComponent } from './components/acquisition/create-acquisition/document/document.component';
// import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { DocumentFacade } from "../../../generic-document/src/lib/document-states/document.facade";
import { GenericDocumentModule } from "../../../generic-document/src/lib/generic-document.module";
import { AddressBookComponent } from './components/acquisition/create-acquisition/address-book/address-book.component';
import { AddressBookListComponent } from './components/acquisition/create-acquisition/address-book/address-book-list/address-book-list.component';
import { DocumentTableComponent } from './components/acquisition/create-acquisition/document/document-table/document-table.component';
import { LessorComponent } from './components/acquisition/create-acquisition/lessor/lessor.component';
import { LessorHeaderComponent } from './components/acquisition/create-acquisition/lessor/lessor-header/lessor-header.component';
import { SearchModalComponent } from './components/search-modal/search-modal.component';
import { LessorInfoListComponent } from './components/acquisition/create-acquisition/lessor/lessor-info-list/lessor-info-list.component';
import { LessorMainViewComponent } from './components/acquisition/create-acquisition/lessor/lessor-main-view/lessor-main-view.component';
import { SurveyAreaComponent } from './components/acquisition/create-acquisition/lessor/lessor-main-view/survey-area/survey-area.component';
import { SurveyAreaTableComponent } from './components/acquisition/create-acquisition/lessor/lessor-main-view/survey-area/survey-area-table/survey-area-table.component';
import { LessorRepresentativeComponent } from './components/acquisition/create-acquisition/lessor/lessor-main-view/lessor-representative/lessor-representative.component';
import { IndividualAcreagesComponent } from './components/acquisition/create-acquisition/lessor/lessor-main-view/individual-acreages/individual-acreages.component';
import { LessorRepresentativeTableComponent } from './components/acquisition/create-acquisition/lessor/lessor-main-view/lessor-representative/lessor-representative-table/lessor-representative-table.component';
import { IndividualAcreagesTableComponent } from './components/acquisition/create-acquisition/lessor/lessor-main-view/individual-acreages/individual-acreages-table/individual-acreages-table.component';
import { LandParcellationTableComponent } from './components/acquisition/create-acquisition/land-parcellation/land-parcellation-table/land-parcellation-table.component';
import { StorageLocationTableComponent } from './components/acquisition/create-acquisition/storage-location/storage-location-table/storage-location-table.component';
import { AddressBookSearchComponent } from './components/acquisition/create-acquisition/address-book/address-book-search/address-book-search.component';
import { LessorInfoListModalComponent } from './components/acquisition/create-acquisition/lessor/lessor-info-list/lessor-info-list-modal/lessor-info-list-modal.component';
import { PreviousLandNameModalComponent } from './components/acquisition/create-acquisition/previous-land-name-modal/previous-land-name-modal.component';
import { AssetLocationComponent } from './components/acquisition/create-acquisition/asset-location/asset-location.component';
import { AssetLocationTableComponent } from './components/acquisition/create-acquisition/asset-location/asset-location-table/asset-location-table.component';
import { ExcelDocumentUploadViewComponent } from './components/acquisition/create-acquisition/document/document-table/excel-document-upload-view/excel-document-upload-view.component';
import { COfOComponent } from './components/acquisition/create-acquisition/c-of-o/c-of-o.component';
import { OrderByPipe } from './order-by.pipe';
import  { StakeholderTableComponent } from './components/acquisition/create-acquisition/lessor/lessor-main-view/stakeholder/stakeholder-table/stakeholder-table.component';
import  { StakeholderComponent } from './components/acquisition/create-acquisition/lessor/lessor-main-view/stakeholder/stakeholder.component';
import { LandTitleReportComponent } from './components/land-title-report/land-title-report.component';
import { LandTitleReportContainerComponent } from './containers/land-title-report-container/land-title-report-container.component';
import { NgxPrintModule } from 'ngx-print';
import { ReportSearchComponent } from './components/report-search/report-search.component';

@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    AcquisitionRoutingModule,
    EpimsDashboardNavModule,
    SpinnersModule,
    ReactiveFormsModule,
    GenericDocumentModule,
    PaymentModule,
    NgxPrintModule,
    AngularMaterialModule,
    StoreModule.forFeature(
      acquisitionReducer.ACQUISITION_FEATURE_KEY,
      acquisitionReducer.reducer,
    ),

    StoreModule.forFeature(
      acquisitionGenericReducer.ACQUISITION_GENERIC_FEATURE_KEY,
      acquisitionGenericReducer.reducer,
    ),

    StoreModule.forFeature(
      acquisitionGenericReducer.ACQUISITION_GENERIC_ADDRESS_BOOK_FEATURE_KEY,
      acquisitionGenericReducer.addressBookReducer,
    ),

    StoreModule.forFeature(
      acquisitionGenericReducer.ACQUISITION_GENERIC_PARCEL_FEATURE_KEY,
      acquisitionGenericReducer.landParcelReducer,
    ),

    StoreModule.forFeature(
      acquisitionGenericReducer.ACQUISITION_GENERIC_LESSOR_INFO_FEATURE_KEY,
      acquisitionGenericReducer.lessorInfoReducer,
    ),

    StoreModule.forFeature(
      acquisitionGenericReducer.ACQUISITION_GENERIC_LESSOR_AREA_MAKER_FEATURE_KEY,
      acquisitionGenericReducer.lessorAreaMakerReducer,
    ),

    StoreModule.forFeature(
      acquisitionGenericReducer.ACQUISITION_GENERIC_LESSOR_REPRESENTATIVE_FEATURE_KEY,
      acquisitionGenericReducer.lessorRepresentativeReducer,
    ),

    StoreModule.forFeature(
      acquisitionGenericReducer.ACQUISITION_GENERIC_LESSOR_STAKEHOLDER_FEATURE_KEY,
      acquisitionGenericReducer.lessorStakeholderReducer,
    ),

    StoreModule.forFeature(
      acquisitionGenericReducer.ACQUISITION_GENERIC_INDIVIDUAL_ACREAGES_FEATURE_KEY,
      acquisitionGenericReducer.individualAcreagesReducer,
    ),

    StoreModule.forFeature(
      acquisitionGenericReducer.ACQUISITION_GENERIC_ASSET_LOCATION_FEATURE_KEY,
      acquisitionGenericReducer.assetLocationReducer,
    ),

    StoreModule.forFeature(
      acquisitionGenericReducer.ACQUISITION_GENERIC_CREATED_USER_FEATURE_KEY,
      acquisitionGenericReducer.createdUserReducer,
    ),
    StoreModule.forFeature(
      acquisitionGenericReducer.ACQUISITION_GENERIC_MODIFY_USER_FEATURE_KEY,
      acquisitionGenericReducer.modifyUserReducer,
    ),

    EffectsModule.forFeature([
      AcquisitionGenericEffects,
      AcquisitionEffects,
    ]),
  ],
  providers: [
    AcquisitionGenericFacade,
    AcquisitionFacade,
    DocumentFacade,
    GatewayFacade
  ],
  declarations: [
    AcquisitionContainerComponent,
    AcquisitionComponent,
    AcquisitionListComponent,
    SearchComponent,
    CreateAcquisitionComponent,
    MeasurementConversionTableComponent,
    LandParcellationComponent,
    GeoSpatialComponent,
    StorageLocationComponent,
    DocumentComponent,
    AddressBookComponent,
    AddressBookListComponent,
    DocumentTableComponent,
    LessorComponent,
    LessorHeaderComponent,
    SearchModalComponent,
    LessorInfoListComponent,
    LessorMainViewComponent,
    SurveyAreaComponent,
    SurveyAreaTableComponent,
    LessorRepresentativeComponent,
    IndividualAcreagesComponent,
    LessorRepresentativeTableComponent,
    IndividualAcreagesTableComponent,
    LandParcellationTableComponent,
    StorageLocationTableComponent,
    AddressBookSearchComponent,
    LessorInfoListModalComponent,
    PreviousLandNameModalComponent,
    AssetLocationComponent,
    AssetLocationTableComponent,
    ExcelDocumentUploadViewComponent,
    COfOComponent,
    OrderByPipe,
    StakeholderTableComponent,
    StakeholderComponent,
    LandTitleReportComponent,
    LandTitleReportContainerComponent,
    ReportSearchComponent,
  ]
})
export class AcquisitionModule {}
